import Head from 'next/head'
import type { FC } from 'react'
import { Container } from 'components/ui'
import Layout, { Breadcrumb, BreadcrumbProps } from 'components/layout'
import { SellersView } from 'modules/sellers/containers'
import { ROUTE_SELLER_INDEX } from 'routes/sellers'
import s from './sellers.module.css'

interface SellersProps {}

const Sellers: FC<SellersProps> = () => {
  const crumbs: BreadcrumbProps['crumbs'] = [{ url: ROUTE_SELLER_INDEX, label: 'Produtores' }]

  return (
    <Layout>
      <Head>
        <title>Produtores</title>
      </Head>
      <Breadcrumb crumbs={crumbs} />
      <Container className={s.root}>
        <div className={s.header}>
          Na Fazendinha, a tecnologia aproxima produtores e compradores, num modelo do produtor à mesa, onde você compra
          e recebe diretamente de quem produz. Aqui você encontra produtos locais, típicos, artesanais e orgânicos,
          produzidos por pessoas, suas histórias e valores. Produtores que transformam sonhos em alimentos, em sabores e
          aromas! Comida de verdade!!!
        </div>
        <SellersView />
        <div className={s.footer}>
          <div className={s.title}>Comprando do produtor local</div>
          <p>
            A forma como nos alimentamos tem profunda influência no mundo a nossa volta: seja na paisagem, na
            biodiversidade da terra, na economia local ou na nossa cultura e tradições.
          </p>
          <p>
            Quando compramos diretamente do produtor contribuímos para melhorar a economia local, promovendo o seu
            desenvolvimento, fazendo o lugar onde vivemos prosperar.
          </p>
          <div className={s.subtitle}>Alimentando as relações</div>
          <p>
            Quando você compra diretamente do produtor, você também alimenta as relações, conhecendo e valorizando quem
            produz o que chega até a sua mesa. Estimula a diversidade alimentar, as culturas locais e o desenvolvimento
            das comunidades no campo.
          </p>
        </div>
      </Container>
    </Layout>
  )
}

export default Sellers
